'use client'

import { Builder, withChildren } from '@builder.io/react'

import { VideoPopupCTA } from './VideoPopupCTA'

Builder.registerComponent(withChildren(VideoPopupCTA), {
  name: 'Video Popup CTA',
  friendlyName: 'Video Popup CTA',
  defaultChildren: [
    {
      '@type': '@builder.io/sdk:Element',
      '@version': 2,
      component: { name: 'Text', options: { text: 'Play Video', localized: true } },
    },
  ],
  inputs: [
    {
      name: 'videoId',
      friendlyName: 'Video ID',
      type: 'string',
      defaultValue: '6337229270112',
      helperText: 'Brightcove Video ID',
    },
    {
      name: 'playerId',
      friendlyName: 'Player ID',
      type: 'string',
      defaultValue: 'AFPbTgXrMJ',
      helperText: 'Brightcove Player ID',
    },
    {
      name: 'autoplay',
      friendlyName: 'Autoplay',
      type: 'boolean',
      defaultValue: true,
      helperText: 'Set Video Autoplay when open',
    },
  ],
  image: 'https://unpkg.com/@tabler/icons@2.44.0/icons/movie.svg',
})
